export default __webpack_public_path__ + "static/media/tree5.4094a811.svg";